import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { GlobalStyles } from '@mui/material';
import { memo } from 'react';
import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import notificationsStyles from './notificationStyles.js';
/** A `ReactNotifications` component with Material theme style */

var MaterialNotification = memo(function (_ref) {
  var theme = _ref.theme;
  return jsxs(Fragment, {
    children: [jsx(GlobalStyles, {
      styles: notificationsStyles(theme)
    }), jsx(ReactNotifications, {})]
  });
});
export { MaterialNotification };